<template>
    <article>
        <Loader v-if="!mobile" :active="!ready"></Loader>
          <div class="home-wrapper">
            <div ref="main" id="main" class="home">
              <tv-header :window-h="windowH"></tv-header>
              <shows-list :tours="tours" :shows-loaded="showsLoaded" :openTour="openTour"></shows-list>
              <on-demand></on-demand>
              <!-- <latest :fb-posts="fbPosts" :tw-posts="twPosts"></latest> -->
              <about :result="result"></about>
            </div>
            <canvas ref="canvasEl" class="animation-canvas"></canvas>
          </div>
    </article>
</template>

<script>
import axios from 'axios'
import images from '@helpers/images'
import throttle from 'lodash.throttle'
import Loader from './Loader'
import { API_BASE } from '@/config'
import clamp from '@helpers/clamp';

import About from "./Home/About";
import Latest from "./Home/Latest";
import OnDemand from "./Home/OnDemand";
import ShowsList from "./Home/Shows";
import TvHeader from "./TvHeader";

const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export default {
  name: 'home',
  data () {
    return {
      shows: [],
      tours: [],
      result: [],
      fbPosts: [{}, {}, {}],
      twPosts: [],
      images,
      imagesState: [],
      ready: false,
      showScrollDown: true,
      windowH: window.innerHeight,
      windowW: window.innerWidth,
      mobile: false,
      section: 0,
      showsLoaded: false
    }
  },
  components: {
    About,
    Latest,
    Loader,
    OnDemand,
    ShowsList,
    TvHeader,
  },
  mounted () {
    window.scrollTo(0, 0);
    this.mobile = window.innerWidth <= 600;    
    this.windowH = window.innerHeight;
    this.windowW = window.innerWidth;
    this.mainH = this.$refs.main.scrollHeight;
    this.numberOfFrames = 126;
    this.sectionHeight = (this.mainH - this.windowH) / this.numberOfFrames;

    if (!this.mobile) {
      this.loadImages().then(this.init.bind(this))
    }

    this.asyncStuff();
    let that = this;
    setInterval(function() { that.animateTVs(); }, 3000);
  },
  methods: {
    animateTVs () {
      for (var i = 1; i < 6; i++) {
        const wrap = document.getElementsByClassName(`tv-${i}`)[0];
        if (wrap) {
          let image = wrap.getElementsByTagName('img')[0];
          let src = image.src
          image.src = src.replace('.gif', '.jpg');
        }
      }

      let random = Math.floor((Math.random() * 5) + 1);
      const wrap2 = document.getElementsByClassName(`tv-${random}`)[0];

      if (wrap2) {
        const myImage = wrap2.getElementsByTagName('img')[0];
        myImage.src = myImage.src.replace('.jpg', '.gif');
      }

      random = Math.floor((Math.random() * 5) + 1);
      const wrap3 = document.getElementsByClassName(`tv-${random}`)[0];

      if (wrap3) {
        const myImage = wrap3.getElementsByTagName('img')[0] // .getElementsByTagName('img')
        myImage.src = myImage.src.replace('.jpg', '.gif');
      }
    },
    loadImages () {
      return new Promise((resolve, reject) => {
        const promises = this.images.map(this.loadImage);

        Promise.all(promises).then(images => {
          this.initialiseImageState(images);
          resolve()
        })
      })
    },
    loadImage (img) {
      return new Promise(resolve => {
        const image = new Image();

        image.addEventListener('load', () => {
          resolve(image)
        });

        image.src = img
      })
    },
    initialiseImageState (images) {
      this.imagesState = images.map((img, index) => {
        const canvas = this.createOffscreenCanvas();
        const ctx = canvas.getContext('2d');

        const {width, height} = this.getWidthAndHeight(img, canvas);
        const {offsetX, offsetY} = this.getOffsets(width, height, index === 0 ? 'bottom' : 'center');

        ctx.drawImage(img, offsetX, offsetY, width, height);

        return {
          src: img,
          active: index === 0,
          canvas,
          image: img
        }
      })
    },
    getWidthAndHeight (image, canvas) {
      const width = canvas.width;
      const height = image.height * (width / image.width);

      return {width, height}
    },
    getOffsets (imageWidth, imageHeight, type = 'center') {
      const offsetX = 0;
      const offsetY = type === 'center' ? (window.innerHeight / 2) - (imageHeight / 2) : window.innerHeight - imageHeight;

      return {offsetX, offsetY}
    },
    init () {
      this.ready = true;
      this.initialiseCanvas();
      window.addEventListener('resize', this.resizeHandler.bind(this));

      if (!this.mobile) {
        const boundScrollPosition = throttle(this.getScrollPosition.bind(this), 64);

        setTimeout(this.getScrollPosition.bind(this));

        window.addEventListener('scroll', boundScrollPosition)
      }
    },
    resizeHandler () {
      this.mobile = window.innerWidth <= 600;
      this.resizeCanvas()
    },
    initialiseCanvas () {
      this.canvas = this.$refs.canvasEl;
      this.setCanvasDimensions(this.canvas);
      this.ctx = this.canvas.getContext('2d');
    },
    resizeCanvas () {
      if (!this.mobile) {
        this.setCanvasDimensions(this.canvas);
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawImageProp(this.ctx, this.imagesState[this.section].canvas)
      }
    },
    createOffscreenCanvas () {
      const canvas = document.createElement('canvas');
      this.setCanvasDimensions(canvas);

      return canvas
    },
    setCanvasDimensions (canvas) {
      canvas.width = window.innerWidth > 1920 ? 1920 : window.innerWidth;
      canvas.height = window.innerHeight
    },
    getScrollPosition () {
      var scrollObject = {
        x: window.pageXOffset,
        y: window.pageYOffset
      };

      this.showScrollDown = scrollObject.y < 10;
      this.section = parseInt(scrollObject.y / this.sectionHeight);

      if (this.section >= 35 && this.section <= 65) {
        this.section = 35
      }

      if (this.section >= 50) {
        this.section = this.section - 30
      }

      if (this.section >= 94) {
        this.section = 94
      }
      
      this.setCurrentImage(this.section)
    },
    setCurrentImage (index) {        
      this.imagesState.forEach(img => {
        img.active = false
      });

      if (this.imagesState[index]) {
        this.imagesState[index].active = true;
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.drawImageProp(this.ctx, this.imagesState[index].canvas)
      }
    },
    loadWordpressImages (images) {
      let promises = images.map(img => {
        return new Promise(resolve => {
          var image = new Image();

          const timeout = setTimeout(() => {
            resolve()
          }, 3000);

          image.addEventListener('load', () => {
            clearTimeout(timeout);
            resolve()
          });

          image.src = img.background_image.guid
        })
      });

      Promise.all(promises).then(() => {
        this.result = images
      })
    },
    smallBlock (id) {
      return id < 270
    },
    timelineRight () {
      if (document.getElementsByClassName('about-horizontal-list')[0].scrollLeft < 600) {
        document.getElementsByClassName('about-horizontal-list')[0].scrollLeft = 600
      } else {
        document.getElementsByClassName('about-horizontal-list')[0].scrollLeft += 970
      }
    },
    timelineLeft () {
      document.getElementsByClassName('about-horizontal-list')[0].scrollLeft -= 970
    },
    getDateInFormat (date) {
      const d = new Date();
      d.setFullYear(parseInt(date.substring(0, 4)), parseInt(date.substring(5, 7) - 1), parseInt(date.substring(8, 10)));
      const day = date.substring(8, 10);
      const weekdayNames = ['Sun', 'Mon', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat'];
      const dayFormat = this.getDayFormat(day);

      return weekdayNames[parseInt(d.getDay())] + ' ' + parseInt(day) + dayFormat + ' ' //  d.getDate() + dayFormat + ' ' + monthNames[d.getMonth()]
    },
    getDayFormat (date) {
      const dateString = date.toString();
      const lastNumber = parseInt(dateString[dateString.length - 1]);

      if (lastNumber === 1) {
        return 'st'
      }

      if (lastNumber === 2) {
        return 'nd'
      }

      if (lastNumber === 3) {
        return 'rd'
      }

      return 'th'
    },
    getDateInFormatTW (tWDate) {
      let twDateArray = tWDate.split(' ');
      return twDateArray[2] + ' ' + twDateArray[1] + ' ' + twDateArray[5]
    },
    getDateInFormatLatest (date) {
      const d = new Date(date);
      const dayFormat = this.getDayFormat(d.getDate());

      return d.getDate() + dayFormat + ' ' + monthNames[d.getMonth()] + ' ' + d.getFullYear()
    },
    getSocialMedia () {
      const pageAccessToken = '495265850852276|SDLVC2YS92S7lcqVupbxpc12_Jc';

      setTimeout(() => {
        if (window.FB) {
          window.FB.api('/Ross.Noble/feed',
            {
              access_token: pageAccessToken,
              limit: 10
            },
            (response) => {
              if (response.data) {
                this.fbPosts = response.data.map((el, i) => {
                  const date = this.getDateInFormatLatest(response.data[i].created_time.substring(0, 10));
                  setTimeout(function() {
                    for (var i = 0; i < 6; i++) {
                      let paragraph = document.getElementsByClassName('fb-post-paragraph');
                      clamp(paragraph[i], {clamp: 6, useNativeClamp: false, truncationChar: ' ', truncationHTML: `<a class='see-more' href="https://www.facebook.com/Ross.Noble/" target='_blank'>...SEE MORE</a>`});
                    }
                  }, 10)
                  return {
                    message: el.message,
                    date
                  }
                })
              }
            }
          )
        }
      }, 500)
    },
    openTour (tour, index) {
      if (!tour.open) {
        for (var i = 0; i < this.tours.length; i++) {
          if (i !== index) {
            this.tours[i].open = false;
          }
        }
      }
      tour.open = !tour.open;        
    },
    mutateToursData (tours) {
      let mutatedTours = tours.map(tour => {
        return Object.assign({}, tour, { open: false });
      });

      mutatedTours.forEach(tour => {
        if (tour.shows) {
          tour.shows = this.separateTourShowsByMonth(tour.shows);
        }
      });

      return mutatedTours.filter(tour => tour.shows && tour.shows.length);
    },
    separateTourShowsByMonth (shows = []) {
      let sortedShows = Object.assign([], shows)
      
      sortedShows.sort((a, b) => new Date(a.show_date) - new Date(b.show_date));

      let showsByMonth = monthNames.map((month, index) => {
        return {
          name: month,
          index,
          shows: []
        };
      });

      sortedShows.forEach(show => {
        const currentDate = new Date();
        const date = new Date(show.show_date);

        if (date - currentDate > 0) {
          showsByMonth[date.getMonth()].shows.push(show);
        }          
      });

      return showsByMonth.filter(month => month.shows.length);
    },
    asyncStuff () {
      axios.get(`${API_BASE}/wp/wp-json/wp/v2/show_tours`).then(response => {
        this.tours = this.mutateToursData(response.data).sort((a, b) => new Date(a.start_of_tour_date) - new Date(b.start_of_tour_date));
        if(this.tours[0] !== undefined) {
          this.tours[0].open = true; 
        }
        
        this.showsLoaded = true;
      })

      axios.get(`${API_BASE}/wp/wp-json/wp/v2/about?per_page=100`)
        .then(response => void this.loadWordpressImages(response.data)
        );
        
     /*  axios.get(`${API_BASE}/twitter.php`)
        .then(response => {
          this.twPosts = response.data
        });
 */
      setTimeout(() => {
        this.getSocialMedia()
      }, 100)
    },
    /**
     * By Ken Fyrstenberg
     * drawImageProp(context, image [, x, y, width, height [,offsetX, offsetY]])
     * If image and context are only arguments rectangle will equal canvas
     */
    drawImageProp (ctx, img, fromLeft, fromTop, offsetX = 0.5, offsetY = 0.5) {
      const w = ctx.canvas.width;
      const h = ctx.canvas.height;
      const x = 0;
      const y = 0;

      // keep bounds [0.0, 1.0]
      if (offsetX < 0) offsetX = 0;
      if (offsetY < 0) offsetY = 0;
      if (offsetX > 1) offsetX = 1;
      if (offsetY > 1) offsetY = 1;

      let iw = img.width;
      let ih = img.height;
      let r = Math.min(w / iw, h / ih);
      let nw = iw * r;
      let nh = ih * r;
      let cx = 1;
      let cy = 1;
      let cw = 1;
      let ch = 1;
      let ar = 1;

      // decide which gap to fill
      if (nw < w) ar = w / nw;
      if (nh < h) ar = h / nh;
      nw *= ar;
      nh *= ar;

      // calc source rectangle
      cw = iw / (nw / w);
      ch = ih / (nh / h);

      cx = (iw - cw) * offsetX;
      cy = (ih - ch) * offsetY;

      // make sure source rectangle is valid
      if (cx < 0) {
        cx = 0
      }

      if (cy < 0) {
        cy = 0
      }

      if (cw > iw) {
        cw = iw
      }

      if (ch > ih) {
        ch = ih
      }

      // fill image in dest. rectangle
      ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1,
    h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        text-decoration: none;
    }
</style>



// WEBPACK FOOTER //
// Home.vue?9bf34b70